import { observer } from 'mobx-react-lite';
import { ReactElement, useMemo } from 'react';
import { IChartPoint, ITrainingResult } from '../../jobMetrics.model';
import { IValidJobType, JOB_STATUS, JOB_TYPE } from '../../jobs.model';
import { IJobThreshold } from '../../jobThreshold.store';
import { LossMetrics } from './contents/LossMetrics';
import { MetricsBase } from './contents/MetricsBase';
import { ResultsTable } from './contents/ResultsTable';

interface IProps {
  jobType: IValidJobType;
  loss?: IChartPoint[];
  validationAccuracy?: IChartPoint[];
  trainingAccuracy?: IChartPoint[];
  results: ITrainingResult[];
  recalculateMetrics?: (min: number, max: number) => void;
  threshold?: IJobThreshold | null;
  status: JOB_STATUS;
}

export const LocateObjects = observer((props: IProps): ReactElement => {
  const { jobType, loss, results, recalculateMetrics, threshold, status, validationAccuracy, trainingAccuracy } = props;

  const lossMetrics = useMemo(
    () =>
      loss &&
      validationAccuracy &&
      trainingAccuracy && (
        <LossMetrics
          loss={loss}
          validationAccuracy={validationAccuracy}
          trainingAccuracy={trainingAccuracy}
          status={status}
        />
      ),
    [loss, validationAccuracy, trainingAccuracy]
  );

  return (
    <>
      {jobType === JOB_TYPE.TRAINING && lossMetrics}
      <MetricsBase
        jobType={jobType}
        recalculateMetrics={recalculateMetrics}
        threshold={threshold}
        status={status}
      >
        <ResultsTable
          results={results}
          jobType={jobType}
        />
      </MetricsBase>
    </>
  );
});
